import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { RadioButtonGroup } from 'components';
import { ConfirmationWithRadioProps } from './ConfirmationWithRadio.props';
import { SELECT_AN_OPTION } from '../common/constants';

const ConfirmationWithRadio = ({
  cell,
  confirmationBaseFn,
  defaultValue = 0,
  dialogTitle,
  formLabel,
  onClose = () => {},
  options,
  open,
  size = 'sm',
}: ConfirmationWithRadioProps) => {
  const [selection, setSelection] = useState<number>(defaultValue);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelection(Number(event.target.value));
  };
  const handleConfirm = () => {
    if (confirmationBaseFn) {
      confirmationBaseFn(cell, selection);
    }
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={size}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <RadioButtonGroup
          options={options}
          formLabel={formLabel ?? SELECT_AN_OPTION}
          defaultValue={selection?.toString()}
          ariaLabel={SELECT_AN_OPTION}
          name="radio-button-group"
          handleChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationWithRadio;
